export default {
  "content": "<path d=\"M18.817 4.577L13.931 11.5H17.5v2H13V16h4.5v2H13v4h-2v-4H6.5v-2H11v-2.5H6.5v-2h3.57L5.182 4.577l1.634-1.154L12 10.765l5.183-7.342 1.634 1.154z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};